export const reportRowsFromData = (data) => {
  if (data == null) return [];
  if (Array.isArray(data)) return data;
  if (typeof data === "object") return Object.values(data);
  return [];
};

export const selectReportRenderableRows = (state) => {
  const report = state?.report || {};
  if (report.exportListRows != null) return reportRowsFromData(report.exportListRows);
  const visible = report.isListView?.data != null ? report.isListView.data : report.isListView;
  return reportRowsFromData(visible);
};
